import React from 'react';

import './pages/home.scss';


import Facebook from './images/social-fb.svg';
import Instagram from './images/social-insta.svg';
import LinkedIn from './images/social-linkedin.svg';
import Mail from './images/social-mail.svg';
import Twitter from './images/social-twitter.svg';


const Footer = () => {

  return (
    <div className="footer-wrapper">
      <div className="footer">
        <div className="footer-line-container">
          <div className="footer-line">
                       <a className="footer-link" href="https://www.facebook.com/people/Big-Five-Personality-Test/61593386647191/" target="_blank">  <img src={Facebook} width="25" height="25" alt="facebook" />
            </a>
          <a className="footer-link" href="https://instagram.com/thebigfiveapp/" target="_blank">  <img src={Instagram} width="25" height="25" alt="instagram" />
            </a>
             <a className="footer-link" href="https://twitter.com/BigFiveTest" target="_blank">  <img src={Twitter} width="25" height="25" alt="twitter" />
            </a>
             <a className="footer-link" href="https://www.linkedin.com/company/big-five-personality-test/posts/" target="_blank">  <img src={LinkedIn} width="25" height="25" alt="linkedin" />
            </a>
               <a className="footer-link" href="mailto:thebigfiveapp@gmail.com">
              <img src={Mail} width="25" height="25" alt="mail" />
            </a>
            </div>
        </div>
        <div className="footer-line">
          <div className="footer-text"> copyright @ {new Date().getFullYear()} Jack Upton Technologies Limited
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
